import React from "react";
import Box from "@material-ui/core/Box";
import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import enumParser from "utils/enum-parser";

export const determineCourseSurface = (
  workout: racehorse360.IWorkout,
  classes: Record<string, any>
): JSX.Element | null => {
  const workoutCourseSurfaceCode = enumParser.parseCourseSurface(
    workout.courseSurface
  );
  let workoutCourseSurface: JSX.Element | null;

  if (workoutCourseSurfaceCode === "D") {
    workoutCourseSurface = null;
  } else if (workoutCourseSurfaceCode === "F") {
    workoutCourseSurface = <Box component={"span"}>tr.t</Box>;
  } else if (
    workoutCourseSurfaceCode === "G" ||
    workoutCourseSurfaceCode === "O" ||
    workoutCourseSurfaceCode === "T"
  ) {
    workoutCourseSurface = (
      <Box component={"span"} className={classes.surfaceTurf}>
        {workoutCourseSurfaceCode}
      </Box>
    );
  } else if (workoutCourseSurfaceCode === "I") {
    workoutCourseSurface = (
      <Box component={"span"} className={classes.surfaceTurfInner}>
        {workoutCourseSurfaceCode}
      </Box>
    );
  } else if (
    workoutCourseSurfaceCode === "A" ||
    workoutCourseSurfaceCode === "E"
  ) {
    workoutCourseSurface = (
      <Box component={"span"} className={classes.surfaceTurf}>
        A
      </Box>
    );
  } else if (workoutCourseSurfaceCode) {
    workoutCourseSurface = (
      <Box component={"span"}>{workoutCourseSurfaceCode}</Box>
    );
  }

  return workoutCourseSurface;
};
